export const siteConfig = {
  managementServiceStatus: "preparing", // "available" after registration is confirmed
  pricingVisible: false,
  replyTime: "通常2〜3営業日以内",
  contactFormUrl: "https://forms.gle/CC3BTBAhBMWgQ7HE8",
  stayUrl: "https://stay.tiger-works.jp/",
  pricing: [
    { name: "初回相談", price: "無料" },
    { name: "物件活用・事業性診断", price: "55,000円（税込）から" },
    { name: "開業プロデュース", price: "220,000円（税込）から" },
    { name: "工事発注支援・施工調整", price: "工事費の10〜15%を目安" },
    { name: "運営管理", price: "宿泊売上の30%（清掃費別）" },
  ],
  images: {
    hero: "/works/kusabana-after-tatami.webp",
    story: "/works/kusabana-purchase-exterior.webp",
    renovation: "/works/kusabana-before-living.webp",
    preservedDetails: "/works/japanese_room2.webp",
    afterLiving: "/works/kusabana-after-living.webp",
    afterTatami: "/works/kusabana-after-tatami.webp",
    renovationWork: "/works/kusabana-renovation-work.webp",
    representative: "/works/IMG_8612_1_resize.webp",
    partner: "/works/Interior_coordinator.webp",
  },
  credentials: [],
  performanceMetrics: [],
};
